//-- React Standard
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";

//-- Custom
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";
import Footer from "../Common/Footer/Footer";
import { userActions } from "../../_actions";
import { apiConstants } from "../../_constants/api.constants";
import { Bar, HorizontalBar } from "react-chartjs-2";

class Ride extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rideValue:"1"
    };

    this.graphHandler=this.graphHandler.bind(this);
  }

  /*
   * componentDidMount - Initially it will call and get the users data
   */
  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(userActions.getAllUserCount(apiConstants.GET_ALL_USERS_COUNT));
  }

  /*
   * componentWillReceiveProps - Whenever Props change, it will call and store data
   * update the state values with new props values, this method will get called whenever any change happens to props values
   * componenentDidUpdate()
   */
  componentWillReceiveProps(props) {
    if (props.getUsersList) {
      if (props.getUsersList.getUsersList) {
        if (props.getUsersList.getUsersList.data) {
          // this.setState({
          //   allUser: props.getUsersList.getUsersList.data.allUSer,
          //   normalUser: props.getUsersList.getUsersList.data.normalUser,
          //   driverUser: props.getUsersList.getUsersList.data.driverUser
          // });
        }
      }
    }
  }

  graphHandler(event)
  {
    this.setState({rideValue:event.target.value});
  }

  //-- Main function
  render() {
    const WeeklyData = {
        labels: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday","Saturday","Sunday"],
        datasets: [
          {
            label: "Data",
            backgroundColor: "rgba(75,192,192,1)",
            borderColor: "rgba(75,192,192,1)",
            borderWidth: 2,
            data: [25, 59, 80, 81, 56,100,150]
          }
        ]
      };

      const MonthlyData = {
        labels: ["1", "2", "3", "4", "5"],
        datasets: [
          {
            label: "Data",
            backgroundColor: "rgba(75,192,192,1)",
            borderColor: "rgba(75,192,192,1)",
            borderWidth: 2,
            data: [65, 59, 80, 81, 56]
          }
        ]
      };

      const YearlyData = {
        labels: ["Jan", "Feb", "Mar", "Apr", "May","Jun","Jul","Aug","Sept","Oct","Nov","Dec"],
        datasets: [
          {
            label: "Data",
            backgroundColor: "rgba(75,192,192,1)",
            borderColor: "rgba(75,192,192,1)",
            borderWidth: 2,
            data: [65, 59, 80, 81, 56]
          }
        ]
      };
  
    const { siteConstants } = this.props.language;
    const {rideValue}=this.state;
   
    return (
      <div id="wrapper">
        <SideBar />

        <div id="content-wrapper" className="d-flex flex-column">
          {/* <!-- Main Content --> */}
          <div id="content">
            <TopBar />

            <div className="container-fluid">
              <div className="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 className="h3 mb-0 text-gray-800">
                  {siteConstants.MENU_RIDE}
                </h1>
              </div>

              <div className="card shadow mb-4">
                <div className="card-body">
                  <div className="table-responsive">
                    <div className="row">
                      <div className="col-sm-3"></div>
                      <div className="col-sm-6">
                     
                        <div style={{width:"500px", height: "500px" }}>
                        <Bar
                            data={rideValue==="1" ? WeeklyData : rideValue==="2" ? MonthlyData : YearlyData }
                            options={{
                            title: {
                                display: true,
                                text: "Average Ride",
                                fontSize: 20
                            },
                            legend: {
                                display: true,
                                position: "right"
                            }
                            }}
                        />
                      </div>

                      </div>
                      <div className="col-sm-3">
                        <div className="dataTables_length" id="dataTable_length">
                            <label>
                                <select name="dataTable_length" aria-controls="dataTable" onChange={(e)=>this.graphHandler(e)} className="custom-select custom-select-sm form-control form-control-sm">
                                    <option value="1">Weekly</option>
                                    <option value="2">Monthly</option>
                                    <option value="3">Yearly</option>
                                </select>
                            </label>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- End of Main Content --> */}

          <Footer />
        </div>
      </div>
    );
  }
}

//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
  const { language } = state;
  return {
    language
  };
}

const connectedMembership = connect(mapStateToProps)(Ride);
export { connectedMembership as Ride };
